var React = require('react');

function CrossInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M153.533 136.975L93.324 76.767l60.209-60.209L136.975 0 76.766 60.209 16.558 0 0 16.558l60.209 60.208L0 136.975l16.558 16.558 60.209-60.209 60.208 60.209 16.558-16.558z"}));
}

CrossInline.defaultProps = {"width":"153.533","height":"153.533","viewBox":"0 0 153.533 153.533"};

module.exports = CrossInline;

CrossInline.default = CrossInline;
